module.exports = __webpack_public_path__ + "img/am.c86a9e16.svg";